"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStatementProperty = exports.statementPropertyDefinition = void 0;
exports.statementPropertyDefinition = {
    view: { label: 'Statement' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'statement',
};
const isStatementProperty = (prop) => {
    return prop.name === exports.statementPropertyDefinition.name;
};
exports.isStatementProperty = isStatementProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGVtZW50LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc3RhdGVtZW50LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMkJBQTJCLEdBQUc7SUFDekMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRTtJQUM1QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsV0FBVztDQUNjLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==